import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import * as component from './costa/costa.component';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { navigation_codes } from './core/enum';
import { navigationGuard } from './shared/guards/navigation.guard';
import { SettingComponent } from './setting/setting.component';

const routes: Routes = [
  {
    path: '',
    canActivate: environment.IS_AUTHENTICATED ? [MsalGuard]:[],
    canActivateChild: environment.IS_AUTHENTICATED ? [MsalGuard]:[],
    component: component.CostaComponent,
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard]:[],
      },
      {
        path: 'final-recommendation',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard, navigationGuard]:[],
        loadChildren: () => import('./modules/recommendation.module').then(m => m.RecommendationModule),
        data: {
          navigationCode: navigation_codes['final-recommendation']
        }
      },
      {
        path: 'price-recommendation/recommendation-list',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        loadChildren: () => import('./modules/price-recommender.module').then(m => m.PriceRecommenderModule),
        data: {
          navigationCode: navigation_codes['price-recommender']
        }
      },
      {
        path: 'price-recommendation/priceband-configuration',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        component: SettingComponent,
        data: {
          navigationCode: navigation_codes['price-recommender']
        }
      },
      {
        path: 'scenario/scenario-planner',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        loadChildren: () => import('./modules/scenerio-planner.module').then(m => m.ScenerioPlannerModule),
        data: {
          navigationCode: navigation_codes['scenario-planner']
        }
      },
      // {
      //   path: 'scenario/approved-scenario',
      //   canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
      //   loadChildren: () => import('./modules/scenario-approver.module').then(m => m.ScenarioApproverModule),
      //   data: {
      //     navigationCode: navigation_codes['scenario-planner']
      //   }
      // },
      {
        path: 'scenario/scenario-comparision',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        loadChildren: () => import('./modules/scenario-comparision.module').then(m => m.ScenarioComparisionModule),
        data: {
          navigationCode: navigation_codes['scenario-planner']
        }
      },
      {
        path: 'competitor',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        loadChildren: () => import('./modules/competitor.module').then(m => m.CompetitorModule),
        data: {
          navigationCode: navigation_codes['competitor']
        }
      },
      {
        path: 'price-performance',
        canActivate:  environment.IS_AUTHENTICATED ? [MsalGuard,navigationGuard]:[],
        loadChildren: () => import('./modules/price-performance.module').then(m => m.PricePerformanceModule),
        data: {
          navigationCode: navigation_codes['final-recommendation']
        }
      }
    ],

  }
];

// need to add LazyLoading

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }